import React from "react";
import { Link } from "react-router";
import axios from "axios";
import moment from "moment";
import { getDeep } from "../../functions.js";
import { Courses } from "./Courses";
import * as constants from "../../constants";

const defaultFilters = {
    state: [constants.COURSE_STATE_OPEN]
};

function removeKeysFromObject(object, keysToRemove) {
    return Object.entries(object).reduce((obj, [name, value]) => (keysToRemove.includes(name) ? obj : Object.assign(obj, { [name]: value })), {});
}

export default class CoursesOverview extends React.Component {
    constructor(props) {
        super(props);

        this.cancelToken = axios.CancelToken;
        this.cancelSource = this.cancelToken.source();

        this.state = {
            resultRows: false,
            count: 0,
            limit: 0,
            offset: 0,
            filterTrainers: [],
            filterAccountManagers: [],
            filterInstructors: [],
            activeFilters: defaultFilters
        };
    }

    cancelAxiosRequest = () => {
        this.cancelSource.cancel();

        this.setState({
            resultRows: false
        });
    };

    presetField = "preset";
    presets = {
        // somepreset: {
        //   name: 'Some preset',
        //   overrides: {otherfield: 'new value'},
        //   clears: ['anotherfield']
        // },
        overdue: {
            name: "Overtijd cursussen",
            overrides: { state: [] }
            // clears: ['state']
        },
        "missing-info": {
            name: "Missende informatie",
            overrides: { state: [] }
        }
    };

    componentDidMount = () => {
        // Get if any info is missing
        axios
            .get("/v1/courses/?offset=1&is_editable=true&limit=1&ordering=date&preset=missing-info&state=open")
            .then((response) => {
                if (response && response.data) {
                    this.setState({
                        missingInfo: response.data?.count || response.data?.results?.length || 0
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });

        // // Get trainers for the filter
        axios
            .get("/v1/trainers/?fields=uuid,name&pagination=false&is_active=1")
            .then((response) => {
                if (response && response.data) {
                    let result = [
                        ...response.data.map((item) => {
                            return {
                                value: item.uuid,
                                name: item.name
                            };
                        })
                    ];
                    this.setState({
                        filterTrainers: result
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    render = () => {
        let tableRows = [];
        const now = moment();

        if (this?.state?.missingInfo === undefined) {
            // Poor man's emtpy return as we don't have easy to access Component based loader
            return React.Fragment;
        }

        return (
            <div>
                <div className="section-top">
                    <h1>Cursussen</h1>

                    <div className="section-buttons">
                        {getDeep(this.props.permissions, "course", "create") ? (
                            <Link to="/courses/new" className="btn btn-primary">
                                Cursus toevoegen{" "}
                            </Link>
                        ) : (
                            false
                        )}
                    </div>
                </div>

                {/* We have created a functional component so we can use hooks instead of class based components*/}
                <Courses state={this?.state} />
            </div>
        );
    };
}
